import BApp from "../../../modules/BApp";
import Edible from "./Edible";
import EdibleCollection from "./EdibleCollection";

export default class EdibleContainer
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.diary-day-search-edibles-showcase__edibles`;

	getEdibleCollection()
	{
		return new EdibleCollection(Array.from(this.el.querySelectorAll(Edible.selector())).map(el => {
			return new Edible(el);
		}));
	}

	reset()
	{
		this.el.innerHTML = null;

		return this;
	}

	add(edibles)
	{
		for (let edible of edibles) {
			this.el.append(BApp.createElement(Edible.getEdibleTemplate(edible)));
		}

		return this;
	}

	set(edibles)
	{
		this.reset();

		if (edibles.length) {
			this.add(edibles);
			this.show();
		} else {
			this.hide();
		}

		return this;
	}

	hide()
	{
		this.el.hidden = true;

		return this;
	}

	show()
	{
		this.el.hidden = false;

		return this;
	}
}
